/**
 * FanBoi motion layer — spec section 6.
 * Reveal-on-scroll, page-enter fade, hero parallax, product-card 3D tilt +
 * cursor glow, global cursor spotlight, recently-viewed rendering.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]:not([data-reveal="immediate"])');
    if (!items.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var siblings = Array.prototype.filter.call(
            el.parentElement ? el.parentElement.children : [],
            function (c) { return c.hasAttribute && c.hasAttribute('data-reveal'); }
          );
          var index = siblings.indexOf(el);
          var delay = Math.max(index, 0) * 60;
          setTimeout(function () { el.classList.add('is-visible'); }, delay);
          observer.unobserve(el);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
    );

    items.forEach(function (el) { observer.observe(el); });
  }

  function initPageEnter() {
    if (reducedMotion) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    main.classList.add('fb-page-enter');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        main.classList.add('fb-page-enter--active');
      });
    });
  }

  function initParallax() {
    if (reducedMotion) return;
    var wrappers = document.querySelectorAll('[data-parallax]');
    if (!wrappers.length) return;

    var ticking = false;
    function update() {
      wrappers.forEach(function (wrapper) {
        var img = wrapper.querySelector('img');
        if (!img) return;
        var rect = wrapper.getBoundingClientRect();
        var viewport = window.innerHeight || 1;
        var progress = 1 - (rect.top / viewport);
        progress = Math.min(Math.max(progress, 0), 1);
        img.style.transform = 'translateY(' + (progress * -8) + '%)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function initTiltCards() {
    if (reducedMotion || isTouch) return;
    var cards = document.querySelectorAll('[data-tilt-card]');

    cards.forEach(function (card) {
      var media = card.querySelector('.fb-product-card__media');
      if (!media) return;

      var glow = document.createElement('div');
      glow.className = 'fb-product-card__glow';
      glow.setAttribute('aria-hidden', 'true');
      media.appendChild(glow);

      card.addEventListener('mousemove', function (e) {
        var rect = media.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        var rotateY = (px - 0.5) * 12;
        var rotateX = (0.5 - py) * 12;
        media.style.transform = 'rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg)';
        glow.style.opacity = '1';
        glow.style.background =
          'radial-gradient(circle at ' + (px * 100).toFixed(1) + '% ' + (py * 100).toFixed(1) + '%, ' +
          'color-mix(in oklab, var(--primary) 18%, transparent), transparent 60%)';
      });

      card.addEventListener('mouseleave', function () {
        media.style.transform = '';
        glow.style.opacity = '0';
      });
    });
  }

  function initCursorGlow() {
    if (reducedMotion || isTouch) return;

    var glow = document.createElement('div');
    glow.className = 'fb-cursor-glow';
    glow.setAttribute('aria-hidden', 'true');
    document.body.appendChild(glow);

    var targetX = window.innerWidth / 2;
    var targetY = window.innerHeight / 2;
    var curX = targetX;
    var curY = targetY;

    window.addEventListener('mousemove', function (e) {
      targetX = e.clientX;
      targetY = e.clientY;
      glow.style.opacity = '1';
    });
    document.addEventListener('mouseleave', function () { glow.style.opacity = '0'; });

    function loop() {
      curX += (targetX - curX) * 0.15;
      curY += (targetY - curY) * 0.15;
      glow.style.transform = 'translate(' + (curX - 160) + 'px, ' + (curY - 160) + 'px)';
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  }

  function renderRecentlyViewed() {
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    var maxItems = parseInt(section.getAttribute('data-max-items'), 10) || 4;

    var stored;
    try {
      stored = JSON.parse(localStorage.getItem('fb_recently_viewed') || '[]');
    } catch (e) {
      stored = [];
    }

    var currentPath = window.location.pathname;
    stored = stored.filter(function (p) { return p && p.url && p.url !== currentPath; }).slice(0, maxItems);
    if (!stored.length) return;

    grid.innerHTML = stored.map(function (p) {
      return (
        '<a href="' + p.url + '" class="fb-product-card">' +
          '<div class="fb-product-card__media">' +
            '<img class="fb-product-card__img fb-product-card__img--first" src="' + p.image + '" alt="" loading="lazy">' +
          '</div>' +
          '<div class="fb-product-card__meta">' +
            '<div><div class="fb-product-card__title">' + p.title + '</div></div>' +
            '<span class="fb-price">' + p.price + '</span>' +
          '</div>' +
        '</a>'
      );
    }).join('');

    section.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initPageEnter();
    initParallax();
    initTiltCards();
    initCursorGlow();
    renderRecentlyViewed();
  });
})();
